module.exports = __webpack_public_path__ + "static/ant-financial-logo-cfe9472b8d8ef8757a8a98c10391ca48.jpg";